// removed by extract-text-webpack-plugin
module.exports = {"headerRow":"_2N-zMXXwD8OzWfPa1PycVE","headerTitle":"_2uriXc5iEa8PHnk94SstNG","testTitle":"_3u0MzQW6sG5RayN0BxClXC","testBody":"WJHU0m8bzPPPtCe1nflNA","testCopy":"_2Pmi37IHuKyeoJbYUpG528","testButton":"_2H9jvp45S-txK9ljnfiN5_","retakeButton":"GaW-plxsQkPGFrsMnkPcf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ClientMode/Tests.css
// module id = 398
// module chunks = 0